import { WORKER_URL } from '../config.js';
import { getSession } from './auth_utils.js';
import { fetchCache } from './fetchCache.js';

const authGetJson = async (path) => {
  const session = await getSession();
  if (!session?.access_token) throw new Error('Authentication required');
  const result = await fetchCache.fetchJSON(`${WORKER_URL}${path}`, {
    method: 'GET',
    skipCache: true,
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
  });
  if (!result?.success) throw new Error(result?.error || 'Failed to load owned items');
  return result;
};

export const fetchOwnedCharactersForEdit = async () => {
  const result = await authGetJson('/owned/characters');
  return Array.isArray(result.characters) ? result.characters : [];
};

export const fetchOwnedCharacterForEdit = async (characterId) => {
  const result = await authGetJson(`/owned/characters/${characterId}`);
  return result.character || null;
};

export const fetchOwnedScenariosForEdit = async () => {
  const result = await authGetJson('/owned/scenarios');
  return Array.isArray(result.scenarios) ? result.scenarios : [];
};

export const fetchOwnedScenarioForEdit = async (scenarioId) => {
  const result = await authGetJson(`/owned/scenarios/${scenarioId}`);
  return result.scenario || null;
};
